import React from 'react';
import './TabComponents.scss';
import { Card, Figure } from 'react-bootstrap';
import DataEntryLogo from '../../assets/images/tabImages/DataEntrySVG.svg';

interface DataEntryProps {
  dataEntry: number,
  onClick: () => void,
}

function DataEntry(props: DataEntryProps) {
  return (
    <Card className="cardBorderStyle">
      <Card.Body className='border-none'>
        <Figure className='mb-0'>
          <Figure.Image
            src={DataEntryLogo}
            alt='DataEntryLogo'
            className='mr-2 float-left'
          />
          <Figure.Caption className='figure-caption-custom mt-1 data-entryCaption'>
            Data Entry
          </Figure.Caption>
        </Figure>
        <span className='card-data'>
          <span
            className="totalRecordCount"
            onClick={(event) => {
              event.stopPropagation();
              props.onClick();
            }}
          >
            {props.dataEntry}
          </span>
        </span>
      </Card.Body>
    </Card>
  );
}
export default DataEntry;
